import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CardComponent } from './card.component'
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '@ngx-interact-ui/core';

@NgModule({
  declarations: [CardComponent],
  imports: [CommonModule, TranslateModule, TooltipModule],
  exports: [CardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CardModule {}